import _taggedTemplateLiteral from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  15% { transform: translateX(5px); }\n  30% { transform: translateX(-5px); }\n  45% { transform: translateX(4px); }\n  60% { transform: translateX(-2px); }\n  75% { transform: translateX(1px); }\n  90% { transform: translateX(0); }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from {\n    bottom: 2rem;\n  }\n\n  to {\n    bottom: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { keyframes } from "../styled";
/**
 * Basic fade-in animation
 */

export var fadeIn = keyframes(_templateObject());
/**
 * Slides the component from bottom.
 */

export var slideDown = keyframes(_templateObject2());
/**
 * Pulse animation
 */

export var opacityPulse = keyframes(_templateObject3());
/**
 * Basic shake animation
 */

export var shake = keyframes(_templateObject4());